/*
 * @Author: Liux
 * @Date: 2019-09-24 07:26:32
 * @LastEditor: Liux
 * @LastEditTime: 2022-07-01 14:33:29
 */
import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { InfoService } from './domain/service';
declare var require: any
var noDataModule = require('highcharts/modules/no-data-to-display.js');
import Drilldown from 'highcharts/modules/drilldown';
import * as Highcharts from 'highcharts';
import { InsightsService } from './infrastructure';

noDataModule(Highcharts);
Drilldown(Highcharts);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private info: InfoService,
    private insightsService: InsightsService
  ) {
    var branding = this.info.getBranding();
    this.loadStyle(branding);
    this.autoScaleInMobile();
  }

  autoScaleInMobile() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
      var ww = (window.innerWidth < window.screen.width) ? window.innerWidth : window.screen.width; //get proper width
      var mw = 1024; // min width of site
      var ratio = ww / mw; //calculate ratio
      if (ww < mw) { //smaller than minimum size
        document.getElementById("viewport").setAttribute("content", 'initial-scale=' + ratio + ', user-scalable=yes, width=device-width');
      } else { //regular size
        document.getElementById("viewport").setAttribute("content", 'initial-scale=1.0, user-scalable=yes, width=device-width');
      }
    }
  }

  loadStyle(branding: string) {
    let styleName = '';
    if (branding && branding !== 'default') {
      styleName = 'default-branding-main.css';
    } else {
      styleName = 'default-main.css';
    }
    const head = this.document.getElementsByTagName('head')[0];

    let themeLink = this.document.getElementById(
      'main-theme'
    ) as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = styleName;
    } else {
      const style = this.document.createElement('link');
      style.id = 'main-theme';
      style.rel = 'stylesheet';
      style.href = `${styleName}`;

      head.appendChild(style);
    }
  }

  ngOnInit(): void {
    const userId = this.info.getUserId();
    this.insightsService.trackUserId(userId.toString(), this.info.isInternal() ? 'Internal' : 'External');
  }
}
